import { api as generatedApi } from 'gen/rtk-openapi'
import { TAG_TYPES as COMMODITY_TAG_TYPES } from './inventory'

export const TAG_TYPES = {
  inventoryAdjustments: 'InventoryAdjustments',
  inventoryCommodity: 'InventoryCommodity',
}

export const api = generatedApi.enhanceEndpoints({
  addTagTypes: [TAG_TYPES.inventoryAdjustments],
  endpoints: {
    getInventoryAdjustments: {
      providesTags: result =>
        result && result.Items
          ? [
              ...result.Items.map(inventoryAdjustment => ({
                type: TAG_TYPES.inventoryAdjustments,
                id: inventoryAdjustment.id,
              })),
              { type: TAG_TYPES.inventoryAdjustments, id: 'LIST' },
            ]
          : [{ type: TAG_TYPES.inventoryAdjustments, id: 'LIST' }],
    },
    getInventoryAdjustment: {
      providesTags: (result, error, { id }) => [{ type: TAG_TYPES.inventoryAdjustments, id }],
    },
    createInventoryAdjustment: {
      invalidatesTags: () => [
        { type: TAG_TYPES.inventoryAdjustments, id: 'LIST' },
        { type: TAG_TYPES.inventoryCommodity, id: 'LIST' },
      ],
    },
    updateInventoryAdjustment: {
      invalidatesTags: (result, error, { id }) => [
        { type: TAG_TYPES.inventoryAdjustments, id },
        { type: TAG_TYPES.inventoryAdjustments, id: 'LIST' },
        { type: TAG_TYPES.inventoryCommodity, id: 'LIST' },
      ],
    },
    deleteInventoryAdjustment: {
      invalidatesTags: (result, error, { id }) => [
        { type: TAG_TYPES.inventoryAdjustments, id: 'LIST' },
        { type: TAG_TYPES.inventoryAdjustments, id },
        { type: TAG_TYPES.inventoryCommodity, id: 'LIST' },
      ],
    },
  },
})

export const {
  useGetInventoryAdjustmentsQuery,
  useGetInventoryAdjustmentQuery,
  useCreateInventoryAdjustmentMutation,
  useUpdateInventoryAdjustmentMutation,
  useDeleteInventoryAdjustmentMutation,
} = api
